import { IGameBlueprint } from "../type"
import json from "@project/data/rogue_4/game/craft.json"

const GAME_BLUEPRINT_DICT: Record<string, IGameBlueprint> = json

export default GAME_BLUEPRINT_DICT
